__webpack_require__.p = "/react-github-popular-repos/";